var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1 mb-5",attrs:{"headers":_vm.Header,"hide-default-footer":"","disable-pagination":""},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('tbody')]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }